// 判断环境，选用不同的store配置
// - 仅在开发环境使用redux调试工具，其他一样
/* eslint-disable global-require */
if (process.env.JS_ENV === 'development') {
  module.exports = require('./store.dev');
} else {
  module.exports = require('./store.prod');
}
